import React, { useCallback,useMemo,useEffect, useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import MaterialReactTable from 'material-react-table';
import { Box,
  Button,
  IconButton,
  Typography,
  Tooltip,
} from '@mui/material';
import Axios from '../../lib/axios/axiosInstance';
import { Slide, toast } from 'react-toastify';
import { List, Delete } from '@mui/icons-material';
import { Row, Col } from "react-bootstrap";
import CsvDownloadButton from 'react-json-to-csv'
import { useNavigate, Link, useParams , useSearchParams } from "react-router-dom";
import * as AuthVerify from '../../lib/common';
import { createTheme, ThemeProvider, useTheme } from '@mui/material';

const CustomTable = ({ globalSearch=false }) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState([]);
  const [isError, setIsError] = useState(false);
  const [apiData, setApiData] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  const [columnFilters, setColumnFilters] = useState([]);
  const [columnFilterFns, setColumnFilterFns] = useState({
    templatenum: 'contains',
    templatename : 'contains',
    costcentername: 'contains',
    catalogname: 'contains',
    createdat: 'contains',
    remark: 'contains'
  });
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const tableInstanceRef = useRef(null);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5
  });
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState();

  const findFilterCondition = (name) =>{
    var condition = '';
    if(columnFilterFns[name]){
      condition = columnFilterFns[name];
    }
    return condition;
  }

  const fetchDataFromAPI = async (reset=false) => {
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    
    let filterQuery='';
    let sorterQuery='';

    if(!reset){
      if(columnFilters.length>0){
        columnFilters.forEach(element => {
          filterQuery+=`&filter=${element.id},${findFilterCondition(element.id)},${element.value}`;
        });
      }
      if(sorting.length > 0){
        sorting.forEach(element => {
          sorterQuery+=`&sortby=${element.id}&orderby=${element.desc?'desc':'asc'}`;
        });
      }
    }else{
      setPagination({
        pageIndex: 0,
        pageSize: 5
      });
      tableInstanceRef.current.resetRowSelection();
    }

    //Get Order Templates
    //api/account/ordertemplate
    let url = `/account/ordertemplate?limit=${pagination.pageSize}&offset=${pagination.pageIndex * pagination.pageSize}${sorterQuery}${filterQuery}`;
    await Axios.get(url)
      .then(function (response) {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
        if (response && response.data?.data) {
          setData(response.data?.data.orders.items??[]);
          setRowCount(response.data?.data.orders.count);
        }
        else {
          toast.error(response.statusText ?? "Data fetching failed !", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
          });
        }
      })
      .catch(function (error) {
        // navigate('/');
      });
  };


  useEffect(() => {
    fetchDataFromAPI();
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting
  ]);

  const columns = useMemo(
    () => [
      {
        accessorKey: 'templatenum',
        header:  "Template #",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorFn: (row) => row.templatename,
        id: 'templatename',
        // enableColumnFilter: false,
        // enableSorting: false,
        // enableColumnFilterModes: false,
        header: 'Template Name',
        enableEditing : false,
        size:50,
        Cell: ({ cell, row }) => (
          // <a href="#">
          //   <img style={{ maxHeight: "60px" }} src={AuthVerify.getImageLink(row.original.imageurl)} alt="Product" />
          // </a>
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'costcentername',
        header:  "Cost Center Name",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'catalogname',
        header: "Catalog Name",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'createdat',
        header:  "Created Date",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()?cell.getValue().split('T')[0]:""}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'remark',
        header:  "Remark",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      }/* ,
      {
        accessorKey: 'sharedtocc',
        header:  "Share with other purchaser in costcenter",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()?'True':'False'}</Typography>
        ),
        size:50,
        enableColumnFilterModes: false,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      } */
      //end
    ],
    [],
  );

  const handleDeleteRow = async () => {
    await Axios.delete(`/account/ordertemplate/${selectedTemplate}`)
      .then(async (res) => {
        if (res.data?.success) {
          toast.success('Template deleted successfully', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
          });
        }
        else {
          toast.error('Unable to delete template', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
          });
        }
      })

    setShowConfirmDeleteModal(false);
    fetchDataFromAPI(true);
  }

  const globalTheme = useTheme(); //(optional) if you already have a theme defined in your app root, you can import here

  const theme = useMemo(
    () =>
      createTheme({
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: '1.1rem', //override to make tooltip font size larger
              },
            },
          }
        },
      }),
    [globalTheme],
  );

  return (
    <>
      <div className="toolbar">
          <div className="row">
              {/* {AuthVerify.getPermissions("Catalog")?.addnew && */}
                  <div className="col-sm-3 text-right" style={{ float: "right" }}>
                      <a href="#" onClick={() => navigate(`/template-details`)}>+ Add New</a>
                  </div>
                  {/* } */}
          </div>
      </div>
      <ThemeProvider theme={theme}>
        <MaterialReactTable
          columns={columns}
          data={data}
          enableColumnActions={false}
          enableGlobalFilter={false}
          enableColumnFilterModes
          initialState={{
            showColumnFilters: false
          }}
          manualFiltering
          manualPagination
          manualSorting
          onColumnFilterFnsChange={setColumnFilterFns}
          onColumnFiltersChange={setColumnFilters}
          onGlobalFilterChange={setGlobalFilter}
          onPaginationChange={setPagination}
          onSortingChange={setSorting}
          tableInstanceRef={tableInstanceRef}
          rowCount={rowCount}
          enableEditing
          state={{
            columnFilters,
            columnFilterFns,
            globalFilter,
            isLoading,
            pagination,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
            sorting,
          }}
          positionActionsColumn="last"
          displayColumnDefOptions={{
            'mrt-row-actions': {
              header: 'Action', //change header text
            },
          }}
          renderRowActions={({ row, table }) => (
            <Box sx={{ display: 'flex', gap: '1rem' }}>
              <Tooltip arrow placement="left" title="Details">
                <IconButton onClick={() => navigate(`/template-details?templatenum=${row.original.templatenum}`)}>
                  <List />
                </IconButton>
              </Tooltip>
              <Tooltip arrow placement="left" title="Remove">
                <IconButton onClick={() => { setShowConfirmDeleteModal(true); setSelectedTemplate(row.original.templatenum) }}>
                  <Delete />
                </IconButton>
              </Tooltip>
            </Box>
          )}
          muiTableHeadCellProps={{
            sx: {
              // fontWeight: 'bold',
              fontSize: '15px',
            },
          }}
          muiTablePaginationProps={{
            sx: {
              fontWeight: 'bold',
              paddingTop: '12px',
              fontSize: '16px',
            },
          }}
          muiTableBodyCellEditTextFieldProps={({ cell, column, row, table }) => ({
            sx: {
              fontSize: '17px'
            },
          })}
          muiTableHeadCellFilterTextFieldProps={{
            sx: {
              fontWeight: 'bold',
              fontSize: '17px',
            },
          }}
        />
      </ThemeProvider>
        {/* <div className="cart_navigation">
          <button className="button btn-proceed-checkout" title="Proceed to Save the Changes" type="button" onClick={() => saveChangesHandler()}><span>Save Changes</span></button>
        </div> */}

      <Modal show={showConfirmDeleteModal} dialogClassName="modal-90w" animation={false} fade={false} style={{ opacity: 1 }} onHide={() => setShowConfirmDeleteModal(false)}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Delete Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Please confirm to proceed.
        </Modal.Body>
        <Modal.Footer>
          <button
            className="button btn-primary"
            type="button"
            onClick={() => handleDeleteRow()}
            style={{
              marginRight: "10px",
              padding: "10px"
            }}
          >
            <span>Confirm</span>
          </button>
          <button
            className="button btn-primary"
            type="button"
            onClick={() => setShowConfirmDeleteModal(false)}
            style={{
              marginRight: "10px",
              padding: "10px"
            }}
          >
            <span>Cancel</span>
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CustomTable;
